import React from 'react';
import styled from 'styled-components';

import { BankCardMethod } from '~/api/finance/financeApiTypes';
import { ConfirmSaveBankCardModal } from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/BankCardMethodPayment/ConfirmSaveBankCardModal';
import { useAppDispatch } from '~/store';

import { choosePayActions } from '../../choosePay.slice';
import { DefaultMethodPaymentParams, MethodPaymentTemplate } from '../MethodPaymentTemplate';

export interface BankCardMethodPaymentPublicProps {
  isShowSaveCardConfirm?: boolean;
}

interface BankCardMethodPaymentProps extends DefaultMethodPaymentParams, BankCardMethodPaymentPublicProps {
  method: BankCardMethod;
}

export const BankCardMethodPayment = ({
  method,
  onCheck,
  isShowSaveCardConfirm = true,
  ...props
}: BankCardMethodPaymentProps) => {
  const dispatch = useAppDispatch();

  const onCheckHandler = () => {
    if (isShowSaveCardConfirm) {
      dispatch(choosePayActions.setIsConfirmSaveBankCardModal(true));
    } else {
      buyHandler();
    }
  };

  const buyHandler = () => {
    if (onCheck) {
      onCheck(method);
    }
  };

  return (
    <>
      <MethodPaymentTemplate
        Logo={(
          <SCIcon
            src="/icon/components/BankCardMethodPayment/bankCardIcon.svg"
          />
        )}
        Text={(
          <>
            {method.name}
          </>
        )}
        onCheck={onCheckHandler}
        {...props}
      />
      <ConfirmSaveBankCardModal onOk={buyHandler} />
    </>
  );
};

const SCIcon = styled.img`
  width: 40px;
  height: 40px;

`;
